import { render, staticRenderFns } from "./buildingForm.vue?vue&type=template&id=1a6d37a0&scoped=true&"
import script from "./buildingForm.vue?vue&type=script&lang=js&"
export * from "./buildingForm.vue?vue&type=script&lang=js&"
import style0 from "./buildingForm.vue?vue&type=style&index=0&id=1a6d37a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6d37a0",
  null
  
)

export default component.exports